import React from "react";
const OfficeLocations = () => <section>hey i'm OfficeLocations</section>;
export default OfficeLocations;
